import * as React from 'react';
import { Table, Avatar, alertColors, IconButton, TimeValue } from '@watcherr/ui';
import { t } from '~/i18n';
import { formatDateTime } from '@watcherr/ui';
import { observer } from 'mobx-react';
import { useGoToAlarm } from '../../hooks/alarm';
import Alert from '~store/Alert/Alert';
import { translateResolveReason } from '~config/alert';
import AlertLogs from '~components/AlertLogs/AlertLogs';

interface AlertTableProps {
  alerts: Alert[];
  deviceVerification?: boolean;
}
const AvatarObserver = observer(({ name }) => {
  const avatar = (
    <Avatar
      userInfo={{
        name: name,
        function: '',
      }}
    />
  );
  return avatar;
});

const AlertTable: React.FC<AlertTableProps> = ({ alerts, deviceVerification }) => {
  const handleAlarmClick = useGoToAlarm();
  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.HeadCol>{t('alerts.table.resident')}</Table.HeadCol>
          <Table.HeadCol>{t('alerts.table.date')}</Table.HeadCol>
          <Table.HeadCol>{t('alerts.table.time')}</Table.HeadCol>
          <Table.HeadCol>{t('alerts.table.answeredBy')}</Table.HeadCol>
          <Table.HeadCol>{t('alerts.table.type')}</Table.HeadCol>
          <Table.HeadCol>{t('alerts.table.resolveReason')}</Table.HeadCol>
          {deviceVerification && <Table.HeadCol>{t('alerts.table.proximityControl')}</Table.HeadCol>}
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {alerts.map((alert) => {
          return (
            <Table.Row key={`alert-table-row-${alert.uuid}`} onClick={handleAlarmClick(alert)}>
              <Table.Col>
                <AvatarObserver name={alert.description} />
              </Table.Col>

              <Table.Col>{formatDateTime(alert.created)}</Table.Col>
              <Table.Col>
                <TimeValue start={alert.created} end={alert.endTime ?? undefined} />
              </Table.Col>

              <Table.Col>
                {alert.answeredBy ? `${alert.answeredBy?.firstName} ${alert.answeredBy?.lastName}` : '-'}
              </Table.Col>

              <Table.Col style={{ color: alertColors[alert.priority] }}>
                {t(`alert.types.${alert.eventType.toLowerCase()}`)}
              </Table.Col>

              <Table.Col>{alert.resolvedReason ? translateResolveReason(alert.resolvedReason) : '-'}</Table.Col>

              {deviceVerification && (
                <Table.Col>
                  <AlertLogs alert={alert} shortVersion={true} />
                </Table.Col>
              )}

              <Table.Col>
                <IconButton icon="eye" />
              </Table.Col>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};
export default AlertTable;
